<template>
	<div class="logo">
		<el-image :src="urLogo" style="height: 40px"></el-image>
	</div>
</template>

<script>
	import { mapGetters } from "vuex"
	import { isEmpty } from "lodash"

	export default {
		name: "Logo",
		data() {
			return {}
		},
		computed: {
			...mapGetters("Auth", ["currentAccount", "currentUser", "getPermissions"]),
			urLogo: function () {
				let types = ["0", "Admin", "marketplace", "3", "agent", "department_store"]
				if (this.currentUser[types[this.currentUser.type_account_id]] === undefined) {
					return require("@/assets/images/logo.png")
				} else {
					let logo
					if (this.currentUser[types[this.currentUser.type_account_id]].uri_logo != undefined) {
						logo = this.currentUser[types[this.currentUser.type_account_id]].uri_logo
					}
					if (this.currentUser[types[this.currentUser.type_account_id]].marketplace != undefined) {
						logo = this.currentUser[types[this.currentUser.type_account_id]].marketplace.uri_logo
					}
					return logo === null ? require("@/assets/images/logo.png") : logo
				}
			}
		},
		methods: {},
		mounted() {
			// let types = ['0', 'Admin', 'marketplace', '3', 'agent', 'department_store']
			// if (this.currentUser.type_account_id === 1) {
			//
			// } else {
			//
			//
			// }
			//
			//
			// // Tipo de conta (1 = Admin | 2 = Marketplace | 4 = Representante | 5 = Estabelecimento Comercial)
			// if (!isEmpty(this.getPermissions.find(x => x === '2'))) {
			//   this.logo = this.currentUser.marketplace.uri_logo
			// }
			// if (!isEmpty(this.getPermissions.find(x => x === '4'))) {
			//   this.logo = this.currentUser.agent.uri_logo
			// }
			// if (!isEmpty(this.getPermissions.find(x => x === '5'))) {
			//   this.logo = this.currentUser.department_store.uri_logo
			// }
		}
	}
</script>
<style lang="scss">
	.logo .el-image {
		transition: all 0.2s ease;
	}
</style>
